module.exports = __webpack_public_path__ + "media/images/flags/64/Liberia-6e393599e63b7b1cdae19e9f4e3253dc.png";